import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd9142e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "staff-order h-full w-11 flex flex-column",
  style: {"max-height":"60vh"}
}
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "pr-2 text-sm" }
const _hoisted_4 = { class: "flex align-items-center" }

import { set } from "@vueuse/core";
import { ref, watchEffect, watch } from "vue";
import { IStaff } from "@/clinic/typings";
import OrderList from "primevue/orderlist";


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffOrder',
  props: {
    staffs: null
  },
  emits: ["update-distributed-staffs", "order-distributed-staffs"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  staffs: IStaff[];
};

const staffList = ref<IStaff[]>();





watch(staffList, orderedStaffList => {
  emits(
    "update-distributed-staffs",
    orderedStaffList?.map((staff: IStaff) => staff.id)
  );

  emits("order-distributed-staffs");
});

watchEffect(() => {
  set(staffList, props.staffs);
});

return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(OrderList), {
      class: "w-100",
      listStyle: "height: 100%; max-height: 55vh; padding: 0px;",
      modelValue: staffList.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((staffList).value = $event)),
      dataKey: "id",
      breakpoint: "575px",
      moveUpButtonProps: { name: 'up' },
      moveTopButtonProps: { name: 'top' },
      moveDownButtonProps: { name: 'down' },
      moveBottomButtonProps: { name: 'bottom' }
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(slotProps.index + 1) + ".", 1),
          _createElementVNode("div", _hoisted_4, [
            (slotProps.item.avatar?.url)
              ? (_openBlock(), _createBlock(_component_Avatar, {
                  key: 0,
                  image: slotProps.item.avatar.url,
                  shape: "circle",
                  class: "flex-shrink-0 mr-2"
                }, null, 8, ["image"]))
              : (_openBlock(), _createBlock(_component_Avatar, {
                  key: 1,
                  icon: "pi pi-user",
                  shape: "circle",
                  class: "flex-shrink-0 mr-2"
                })),
            _createElementVNode("span", null, _toDisplayString(slotProps.item.name_kanji), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})